import { HeadLine } from '../../layouts/headers/HeadLine';
import CSS from 'csstype';
import { useRequest } from '../../hooks/useRequest';
import { getApiUrl } from '../../app-config';
import { useParams } from 'react-router-dom';
import FullLoaderComponent from '../../components/loaders/FullLoaderComponent';
import ViewMapComponent from '../../components/maps/ViewMapComponent';
import SpotsGallery from './SpotsGallery';
import './Style.css';

export const SpotView = () => {

    const { spotid } = useParams();

    const { data } = useRequest(getApiUrl('panel/PointsInterest/' + spotid, '1.0'));

    if (!data) {
        return (<FullLoaderComponent msg={'cargando'} />);
    }

    return (
        <div>
            <div className='w-full absolute z-1 head-hi-sm flex flex-col justify-center'>
                <HeadLine title={data.name} backurl='/near-spots' />
            </div>

            <div className="w-full relative content-hi-sm">
                <SpotsGallery images={data?.gallery || []} />
            </div>

            <div className="absolute z-1 w-full border shadow detail-process-food-container pb-4" style={contentStyle}>
                <p className='mt-4'>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ornare, dui facilisis imperdiet mattis, turpis velit porttitor turpis, sit amet blandit lorem risus eu urna. Integer elit massa, tristique at eros nec, viverra mattis orci. Aliquam sit amet facilisis nibh, id fermentum lacus. Integer ac velit faucibus, interdum tortor a, aliquam nibh. Praesent consectetur eros vel augue tempus, sit amet porttitor ex faucibus. Pellentesque condimentum nunc tortor.
                </p>

                <div className='flex mt-4 items-center'>
                    <img src="/assets/img/icons/marketmap-icon.svg" alt="market map" />
                    <div className='txt_s3 ml-2'>Ubicación</div>
                </div>

                <div className='mt-4'>
                    <ViewMapComponent coords={{ lat: data.latitude, lng: data.longitude }} />
                </div>
            </div>
        </div>
    );
};

const contentStyle: CSS.Properties = {
    height: 'calc(100vh - 390px)',
    overflowX: 'hidden'
}